var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isLoggedIn,
          expression: "isLoggedIn"
        }
      ]
    },
    [
      _vm.$router.currentRoute.name == "dashboardMediaCalls"
        ? _c(
            "nav",
            {
              class: _vm.isSuperAdmin ? "admin-sidebar" : "user-sidebar",
              attrs: { id: "sidebar-dashboard" }
            },
            [_c("div", { staticClass: "workflow-title" }, [_vm._v("Workflow")])]
          )
        : _c(
            "nav",
            {
              class: _vm.isSuperAdmin ? "admin-sidebar" : "user-sidebar",
              attrs: { id: "sidebar" }
            },
            [
              _c(
                "ul",
                { staticClass: "list-unstyled components mb-5" },
                [
                  _c(
                    "b-nav-item",
                    { attrs: { to: "/my-week", title: "My Week" } },
                    [
                      _c("img", {
                        attrs: { src: require("@/csmworkflow/img/my-week.svg") }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("My Week")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showMyProject
                    ? _c(
                        "b-nav-item",
                        { attrs: { to: "/my-projects", title: "My Projects" } },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/csmworkflow/img/projects.svg")
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v("My Projects")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    { attrs: { to: "/media-calls", title: "All Media Calls" } },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/csmworkflow/img/media-call-nav.svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("All Media Calls")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.isOnlyMediaPreference
                    ? _c(
                        "b-nav-item",
                        {
                          attrs: { to: "/dashboard", title: "All Deliverables" }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/csmworkflow/img/home.svg")
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "menu-text" }, [
                            _vm._v(_vm._s(_vm.allDeliverableTitle))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showSocialGrouped
                    ? [
                        !_vm.isOnlyMediaPreference
                          ? _c(
                              "b-nav-item",
                              {
                                attrs: {
                                  to: "/social-media-grouped",
                                  title: "Social Media"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/social-media-white.svg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "menu-text" }, [
                                  _vm._v("Social Media")
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm.showSocialSchedule
                    ? [
                        !_vm.isOnlyMediaPreference
                          ? _c(
                              "b-nav-item",
                              {
                                attrs: {
                                  to: "/social-media-schedule",
                                  title: "Social Media"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/social-media-white.svg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "menu-text" }, [
                                  _vm._v("Social Media")
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    : [
                        !_vm.isOnlyMediaPreference
                          ? _c(
                              "b-nav-item",
                              {
                                attrs: {
                                  to: "/social-media",
                                  title: "Social Media"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/social-media-white.svg")
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "menu-text" }, [
                                  _vm._v("Social Media")
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    { attrs: { to: "/project", title: "All Projects" } },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/csmworkflow/img/projects.svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("All Projects")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isSuperAdmin
                    ? [
                        _c(
                          "b-nav-item",
                          {
                            attrs: {
                              to: "/global-search",
                              title: "Global Search"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/search.svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-text" }, [
                              _vm._v("Global Search")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { to: "/calendar", title: "Calendar" } },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/calendar.svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-text" }, [
                              _vm._v("Calendar")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            attrs: {
                              to: "/global-alert",
                              title: "Global Alert"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/bell-regular.svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-text" }, [
                              _vm._v("Global Alert")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { to: "/report", title: "Reports" } },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/report.svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-text" }, [
                              _vm._v("Reports")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            attrs: {
                              to: "/dashboard/media-calls",
                              title: "Media Call Dashboard"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/report.svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-text" }, [
                              _vm._v("Media Call Dashboard")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          { attrs: { to: "/audit-log", title: "Audit Log" } },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/audit-log.svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "menu-text" }, [
                              _vm._v("Audit Log")
                            ])
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSuperAdmin
                    ? _c(
                        "li",
                        {
                          staticClass: "nav-item has-sub-menu",
                          class: { "parent-active": _vm.showAdvancedActive },
                          attrs: { title: "Advanced" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              !_vm.showAdvancedActive
                                ? _vm.checkAdvancedActive(true)
                                : _vm.checkAdvancedActive()
                            }
                          }
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "sub-menu list-unstyled components"
                            },
                            [
                              _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  attrs: { title: "Global Search" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        to: "/global-search",
                                        href: "#",
                                        target: "_self"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/csmworkflow/img/search.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "menu-text" }, [
                                        _vm._v("Global Search")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  attrs: { title: "Calendar" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        to: "/calendar",
                                        href: "#",
                                        target: "_self"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/csmworkflow/img/calendar.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "menu-text" }, [
                                        _vm._v("Calendar")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  attrs: { title: "Global Alert" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        to: "/global-alert",
                                        href: "#",
                                        target: "_self"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/csmworkflow/img/bell-regular.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "menu-text" }, [
                                        _vm._v("Global Alert")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  attrs: { title: "Reports" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        to: "/report",
                                        href: "#",
                                        target: "_self"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/csmworkflow/img/report.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "menu-text" }, [
                                        _vm._v("Reports")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  attrs: { title: "Media Call Dashboard" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        to: "/dashboard/media-calls",
                                        href: "#",
                                        target: "_self"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/csmworkflow/img/report.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "menu-text" }, [
                                        _vm._v("Media Call Dashboard")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "nav-item",
                                  attrs: { title: "Audit Log" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        to: "/audit-log",
                                        href: "#",
                                        target: "_self"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/csmworkflow/img/audit-log.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "menu-text" }, [
                                        _vm._v("Audit Log")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      staticClass: "logout-link d-none d-md-block",
                      attrs: { title: "Logout" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("@/csmworkflow/img/logout.svg") }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-text" }, [
                        _vm._v("Logout")
                      ])
                    ]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "workflow-title" }, [_vm._v("Workflow")])
            ]
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "nav-link", attrs: { href: "#", target: "_self" } },
      [
        _c("img", {
          attrs: { src: "/images/my-week.svg?b7742d1871606e93b1efdb19c3ad6acf" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "menu-text" }, [_vm._v("Advanced")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "expand-menu",
        attrs: { type: "button", id: "sidebarCollapse" }
      },
      [
        _c("img", {
          attrs: { src: require("@/csmworkflow/img/expand-menu.svg") }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }